import { render, staticRenderFns } from "./MigrationNotice.vue?vue&type=template&id=545e4409&scoped=true&"
import script from "./MigrationNotice.vue?vue&type=script&lang=js&"
export * from "./MigrationNotice.vue?vue&type=script&lang=js&"
import style0 from "./MigrationNotice.vue?vue&type=style&index=0&id=545e4409&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e4409",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VChip,VDivider,VIcon,VImg})
